export const colorSchemeAttribute = "data-color-scheme";
